// Sürücü İzinleri — haftalık izin günü seçici (1=Pazartesi ... 7=Pazar).
// İki mod: düzenlenebilir (onToggle verilir) veya salt-okunur (rozet gösterimi).

import React from "react";

import { WEEKDAY_ORDER } from "./availabilityUtils";

const WeekdayChips = ({ selected = [], onToggle, t, readOnly = false, size = "md" }) => {
  const selectedSet = new Set(selected);

  if (readOnly) {
    const active = WEEKDAY_ORDER.filter((d) => selectedSet.has(d));
    if (active.length === 0) {
      return <span className="availability-weekdays__none">{t("driverScheduler.availability.noWeeklyOff")}</span>;
    }
    return (
      <span className="availability-weekdays availability-weekdays--readonly">
        {active.map((d) => (
          <span key={d} className="availability-weekday-chip availability-weekday-chip--static">
            {t(`driverScheduler.availability.weekdayShort.${d}`)}
          </span>
        ))}
      </span>
    );
  }

  return (
    <div className={`availability-weekdays availability-weekdays--${size}`} role="group">
      {WEEKDAY_ORDER.map((d) => {
        const isActive = selectedSet.has(d);
        return (
          <button
            key={d}
            type="button"
            className={`availability-weekday-chip${isActive ? " availability-weekday-chip--active" : ""}`}
            aria-pressed={isActive}
            onClick={() => onToggle?.(d)}
            title={t(`driverScheduler.availability.weekday.${d}`)}
          >
            {t(`driverScheduler.availability.weekdayShort.${d}`)}
          </button>
        );
      })}
    </div>
  );
};

export default WeekdayChips;
